import React from 'react'

const TABS = [
  { id: 'assess',  label: 'Assess Site' },
  { id: 'scan',    label: 'Area Scan' },
  { id: 'compare', label: 'Compare' },
  { id: 'about',   label: 'About' },
]

// The Northflow compass north pointer — a cartographic mark.
// The bright left face and shadow right face represent the lit/shadow sides
// of a compass needle pointing north, directly representing the company name.
function NorthflowMark({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 4 L8 26 L16 21 Z" fill="#22d3ee"/>
      <path d="M16 4 L24 26 L16 21 Z" fill="#22d3ee" fillOpacity="0.22"/>
      <circle cx="16" cy="27.5" r="1.8" fill="#22d3ee" fillOpacity="0.45"/>
    </svg>
  )
}

export default function Header({ activeTab, onTabChange }) {
  return (
    <header className="header">
      <div className="header__brand">
        <NorthflowMark size={28} />
        <div className="header__wordmark">
          <span className="header__company">NORTHFLOW</span>
          <span className="header__product">FLUX</span>
        </div>
      </div>

      <div className="header__rule" />

      <span className="header__descriptor">Energy Grid Intelligence</span>

      <div className="header__spacer" />

      <nav className="header__nav" role="navigation">
        {TABS.map((t, i) => (
          <React.Fragment key={t.id}>
            {i > 0 && <span className="nav__sep" aria-hidden="true" />}
            <button
              className={`nav-link${activeTab === t.id ? ' active' : ''}`}
              onClick={() => onTabChange(t.id)}
            >
              {t.label}
            </button>
          </React.Fragment>
        ))}
      </nav>
    </header>
  )
}
